import { supabase } from "./supabase"
import ENV from "@/env"
import { PoolOverview, PoolOverviewRaw, Candle } from "@/types"
import { Bar, ResolutionString } from "../charting_library/charting_library"
import { getHBBaseUrl } from "@/utils/hb-router"

// {
//   "price_6h_ago": 0.076353363366,
//   "price_1h_ago": 0.084161836479,
//   "market_cap_rank": 1,
//   "total_supply": 201047011,
//   "price_5m_ago": 0.084161836479,
//   "current_price": 0.084161836479,
//   "volume": 3611964,
//   "market_cap": 16920485.664374,
//   "amm_process": "U3Yy3MQ41urYMvSmzHsaA4hJEDuvIm-TgXvSm-wz-X0",
//   "token_name": "BARK",
//   "amm_name": "BARK/AOCRED",
//   "token0": "Sa0iBLPNyJQrwpTTG-tWLQU-1QeUAJA73DdxGGiKoJc",
//   "token1": "8p7ApPZxC_37M06QHVejCQrKsHbcJEerd3jWNkDUWPQ",
//   "price_24h_ago": 0.15903307888,
//   "fixed_supply": 0,
//   "transactions": 22
// }

export async function getOverview(poolIds?: string[], minVolume?: number): Promise<PoolOverview[]> {
  const params: Record<string, any> = {
    min_volume: minVolume || 1,
  }

  if (poolIds) {
    params.pool_ids = JSON.stringify(poolIds)
  }

  const { data, error } = await supabase.functions.invoke("overview", {
    body: params,
  })

  if (error) {
    throw new Error(`Supabase function error: ${error.message}`)
  }

  if (!data) {
    throw new Error("No response from Get-Overview (pools)")
  }

  const raw = data as PoolOverviewRaw[]
  console.log("onPoolOverviewRaw", raw)

  const overviews: PoolOverview[] = raw.map((x: PoolOverviewRaw) => {
    return {
      poolId: x.amm_process, // deprecate in the future
      ammProcess: x.amm_process,
      ammName: x.amm_name || "Unknown",
      ammDiscoveredAtTs: x.amm_discovered_at_ts || 0,
      ammStatus: x.amm_status || "private",
      volume: x.volume || 0,
      totalVolume: x.volume || 0, // deprecate in the future
      volumeUsd: x.volume_usd || 0,
      transactions: x.transactions || 0,
      latestPrice: x.current_price || 0, // deprecate in the future
      currentPrice: x.current_price || 0,
      liquidityUsd: x.liquidity_usd || 0,
      marketCap: x.market_cap || 0, // deprecate in the future
      price5mAgo: x.price_5m_ago || 0,
      price1hAgo: x.price_1h_ago || 0,
      price6hAgo: x.price_6h_ago || 0,
      price24hAgo: x.price_24h_ago || 0,
      token0Price5mAgo: x.token0_price_5m_ago || 0,
      token0Price1hAgo: x.token0_price_1h_ago || 0,
      token0Price6hAgo: x.token0_price_6h_ago || 0,
      token0Price24hAgo: x.token0_price_24h_ago || 0,
      token1Price5mAgo: x.token1_price_5m_ago || 0,
      token1Price1hAgo: x.token1_price_1h_ago || 0,
      token1Price6hAgo: x.token1_price_6h_ago || 0,
      token1Price24hAgo: x.token1_price_24h_ago || 0,
      token0CurrentPrice: x.token0_current_price || 0,
      token1CurrentPrice: x.token1_current_price || 0,
      baseToken: x.token0 || x.token0_process, // deprecate in the future
      quoteToken: x.token1 || x.token1_process, // deprecate in the future
      token1: x.token0_process,
      token1TotalSupply: x.token0_total_supply || 0,
      token1Name: x.token0_name || "Token 0",
      token1Ticker: x.token0_ticker || "T0",
      token1FixedSupply: x.token0_fixed_supply || 0,
      token1Denominator: x.token0_denominator || 0,
      token1MarketCap: x.token0_market_cap || 0,
      token0: x.token1_process || x.token1,
      token0TotalSupply: x.token1_total_supply || 0,
      token0Name: x.token1_name || "Token 1",
      token0Ticker: x.token1_ticker || "T1",
      token0FixedSupply: x.token1_fixed_supply || 0,
      token0Denominator: x.token1_denominator || 0,
      token0MarketCap: x.token1_market_cap || 0,
      status: x.amm_status || "private", // deprecate in the future
      created: x.amm_discovered_at_ts || 0, // deprecate in the future
      microdexi_process_ids: JSON.parse(x.microdexi_process_ids || "[]"),
    }
  })

  console.log("onPoolOverview", overviews)

  return overviews.filter((x) => x.baseToken !== "SpzpFLkqPGvr5ZFZPbvyAtizthmrJ13lL4VBQIBL0dg") // afT
}

export async function getOverviewHB(): Promise<PoolOverview[]> {
  const HB_API = getHBBaseUrl(ENV.VITE_DEXI_CACHE_PROCESS as string)

  const result = await fetch(
    `${HB_API}/${ENV.VITE_DEXI_CACHE_PROCESS}~process@1.0/compute/overview`,
  )

  if (!result.ok) throw new Error("No response from Get-Overview (pools)")

  const resultData = await result.text()

  const raw = JSON.parse(resultData) as PoolOverviewRaw[]

  const overviews: PoolOverview[] = raw.map((x: PoolOverviewRaw) => {
    return {
      poolId: x.amm_process, // deprecate in the future
      ammProcess: x.amm_process,
      ammName: x.amm_name || "Unknown",
      ammDiscoveredAtTs: x.amm_discovered_at_ts || 0,
      ammStatus: x.amm_status || "private",
      volume: x.volume || 0,
      totalVolume: x.volume || 0, // deprecate in the future
      volumeUsd: x.volume_usd || 0,
      transactions: x.transactions || 0,
      latestPrice: x.current_price || 0, // deprecate in the future
      currentPrice: x.current_price || 0,
      liquidityUsd: x.liquidity_usd || 0,
      marketCap: x.market_cap || 0, // deprecate in the future
      price5mAgo: x.price_5m_ago || 0,
      price1hAgo: x.price_1h_ago || 0,
      price6hAgo: x.price_6h_ago || 0,
      price24hAgo: x.price_24h_ago || 0,
      token0Price5mAgo: x.token0_price_5m_ago || 0,
      token0Price1hAgo: x.token0_price_1h_ago || 0,
      token0Price6hAgo: x.token0_price_6h_ago || 0,
      token0Price24hAgo: x.token0_price_24h_ago || 0,
      token1Price5mAgo: x.token1_price_5m_ago || 0,
      token1Price1hAgo: x.token1_price_1h_ago || 0,
      token1Price6hAgo: x.token1_price_6h_ago || 0,
      token1Price24hAgo: x.token1_price_24h_ago || 0,
      token0CurrentPrice: x.token0_current_price || 0,
      token1CurrentPrice: x.token1_current_price || 0,
      baseToken: x.token0 || x.token0_process, // deprecate in the future
      quoteToken: x.token1 || x.token1_process, // deprecate in the future
      token1: x.token0_process,
      token1TotalSupply: x.token0_total_supply || 0,
      token1Name: x.token0_name || "Token 0",
      token1Ticker: x.token0_ticker || "T0",
      token1FixedSupply: x.token0_fixed_supply || 0,
      token1Denominator: x.token0_denominator || 0,
      token1MarketCap: x.token0_market_cap || 0,
      token0: x.token1_process || x.token1,
      token0TotalSupply: x.token1_total_supply || 0,
      token0Name: x.token1_name || "Token 1",
      token0Ticker: x.token1_ticker || "T1",
      token0FixedSupply: x.token1_fixed_supply || 0,
      token0Denominator: x.token1_denominator || 0,
      token0MarketCap: x.token1_market_cap || 0,
      status: x.amm_status || "private", // deprecate in the future
      created: x.amm_discovered_at_ts || 0, // deprecate in the future
      microdexi_process_ids: JSON.parse(x.microdexi_process_ids || "[]"),
    }
  })

  console.log("onPoolOverviewHB", overviews)

  return overviews.filter((x) => x.baseToken !== "SpzpFLkqPGvr5ZFZPbvyAtizthmrJ13lL4VBQIBL0dg") // afT
}
